(function () {
  if (window.__pdPriceUnlockerBound) return;
  window.__pdPriceUnlockerBound = true;

  var ATTEMPT_WINDOW_MS = 30 * 60 * 1000;
  var ATTEMPT_LIMIT = 5;
  var SUBMIT_COOLDOWN_MS = 6000;
  var HASH_SALT = 'pd-email-bonus-v1';
  var ASSET_VERSION = 'tap_cut_v2_2026_06_22_verification_guard';
  var CART_VERIFICATION_MESSAGE = 'Connection verification interrupted the cart update. Please refresh this page, complete the verification if prompted, then try again.';
  var LEGACY_PD_DISCOUNT_CODES = [
    'PDTESTSAVE5',
    'PDTESTSAVE6',
    'PDTESTSAVE7',
    'PDTESTSAVE8',
    'PDTESTSAVE9',
    'PDTESTSAVE10'
  ];

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pd-first-cut]');
    if (!button || event.defaultPrevented) return;

    var root = button.closest('#pd-price-unlocker');
    if (!root) return;

    var saved = readJson(deviceKey(root));
    if (isResultCompatible(root, saved)) {
      revealResult(root, saved);
      return;
    }

    var result = createFirstCutResult(root);
    saveResult(root, result);
    revealResult(root, result, {
      animateFromCents: getCurrentPriceCents(root)
    });
    pushEvent('pd_first_cut', {
      product_id: root.getAttribute('data-product-id') || '',
      saving: centsToMajor(result.savingCents),
      discount_code: result.discountCode
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-pd-email-form]');
    if (!form || event.defaultPrevented) return;

    event.preventDefault();
    var root = form.closest('#pd-price-unlocker');
    if (!root) return;

    var input = form.querySelector('input[name="email"]');
    var button = form.querySelector('button[type="submit"]');
    var email = normalizeEmail(input ? input.value : '');

    hideError(root);

    if (!isValidEmail(email)) {
      showError(root, 'Please enter a valid email address.');
      return;
    }

    var throttle = checkAttemptThrottle(root);
    if (!throttle.ok) {
      showError(root, throttle.message);
      return;
    }
    recordAttempt(root);

    var existingDevice = readJson(deviceKey(root));
    if (existingDevice && existingDevice.stage === 'email_bonus' && isResultCompatible(root, existingDevice)) {
      if (existingDevice.email === email) {
        revealResult(root, existingDevice);
      } else {
        showError(root, 'This browser already reserved an email bonus.');
      }
      return;
    }

    if (button) {
      button.disabled = true;
      button.textContent = 'Revealing...';
    }

    window.setTimeout(function () {
      var result = getOrCreateEmailResult(root, email);
      saveResult(root, result);
      syncToSheet(root, result);
      revealResult(root, result, {
        animateFromCents: Math.max(0, getCurrentPriceCents(root) - getBaseDiscountCents(root))
      });

      if (button) {
        button.disabled = false;
        button.textContent = 'Reveal Extra Cut';
      }

      pushEvent('pd_email_bonus_unlocked', {
        product_id: root.getAttribute('data-product-id') || '',
        email_hash: result.emailHash,
        extra_bonus: centsToMajor(result.emailExtraCents),
        total_saving: centsToMajor(result.savingCents),
        discount_code: result.discountCode
      });
    }, 650);
  });

  document.addEventListener('click', function (event) {
    var claim = event.target.closest('[data-pd-claim]');
    if (!claim || event.defaultPrevented) return;

    var root = claim.closest('#pd-price-unlocker');
    if (!root) return;

    event.preventDefault();

    var result = getActionableResult(root);
    if (!isResultCompatible(root, result)) {
      showMissingUnlockFeedback(root);
      return;
    }

    updateClaimHref(root, result);

    pushEvent('pd_claim_click', {
      product_id: root.getAttribute('data-product-id') || '',
      price: centsToMajor(result.priceCents),
      saving: centsToMajor(result.savingCents),
      discount_code: result.discountCode,
      stage: result.stage
    });

    window.location.href = claim.href;
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pd-add-cart]');
    if (!button || event.defaultPrevented) return;

    var root = button.closest('#pd-price-unlocker');
    if (!root) return;

    event.preventDefault();

    var result = getActionableResult(root);
    if (!isResultCompatible(root, result)) {
      showMissingUnlockFeedback(root);
      return;
    }

    addToCartWithDiscount(root, result, button);
  });

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches('variant-picker input, variant-picker select, input[data-option-position], input[name*="-option"], select[name*="option"], input[name="quantity"]')) return;
    refreshClaimLinksSoon();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('variant-picker, [data-option-value], label[for^="option"], button[name="plus"], button[name="minus"]')) return;
    refreshClaimLinksSoon();
  });

  function boot() {
    initRoots();

    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;

      window.requestAnimationFrame(function () {
        scheduled = false;
        initRoots();
        refreshClaimLinks();
      });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  function initRoots() {
    document.querySelectorAll('#pd-price-unlocker').forEach(function (root) {
      if (root.dataset.pdUnlockerReady === 'true') return;
      root.dataset.pdUnlockerReady = 'true';
      root.dataset.pdUnlockerAssetVersion = ASSET_VERSION;

      var saved = readJson(deviceKey(root));
      if (isResultCompatible(root, saved) && saved.stage === 'email_bonus') {
        revealResult(root, saved);
      } else {
        updateInitialPrice(root);
      }

      pushEvent('pd_unlocker_view', {
        product_id: root.getAttribute('data-product-id') || ''
      });
    });
  }

  function updateInitialPrice(root) {
    root.classList.remove('is-cut', 'is-email-unlocked');
    root.dataset.unlockerState = 'locked';

    setText(root, '[data-top-badge]', 'Tap-to-Save');
    setText(root, '[data-step-badge]', 'TAP TO START');
    setText(root, '[data-unlocker-title]', 'Tap once to cut your price');
    setText(root, '[data-unlocker-subtitle]', 'Guaranteed extra savings.');
    setText(root, '[data-card-label]', 'Your Price');
    setText(root, '[data-card-status]', 'Locked');
    setText(root, '[data-price-value]', '$ --.--');
    setText(root, '[data-price-note]', 'Locked until you tap');
    setText(root, '[data-fineprint]', 'One reserved deal per device.');
    updateReceiptRows(root, null);
  }

  function createFirstCutResult(root) {
    var savingCents = getBaseDiscountCents(root);
    var priceCents = Math.max(0, getCurrentPriceCents(root) - savingCents);
    var totalDollars = Math.round(savingCents / 100);

    return {
      stage: 'first_cut',
      priceCents: priceCents,
      savingCents: savingCents,
      emailExtraCents: 0,
      discountCode: getDiscountCode(root, totalDollars),
      tier: String(totalDollars),
      campaignId: campaignId(root),
      productId: root.getAttribute('data-product-id') || '',
      productHandle: root.getAttribute('data-product-handle') || '',
      clientId: getClientId(),
      createdAt: new Date().toISOString()
    };
  }

  function getOrCreateEmailResult(root, email) {
    var emailHash = String(hashString(email + '|' + campaignId(root)));
    var existingEmail = readJson(emailKey(root, emailHash));
    if (isResultCompatible(root, existingEmail)) return existingEmail;

    var extraCents = deterministicEmailExtraCents(root, email);
    var savingCents = getBaseDiscountCents(root) + extraCents;
    var priceCents = Math.max(0, getCurrentPriceCents(root) - savingCents);
    var totalDollars = Math.round(savingCents / 100);

    return {
      stage: 'email_bonus',
      email: email,
      emailHash: emailHash,
      priceCents: priceCents,
      savingCents: savingCents,
      emailExtraCents: extraCents,
      discountCode: getDiscountCode(root, totalDollars),
      tier: String(totalDollars),
      campaignId: campaignId(root),
      productId: root.getAttribute('data-product-id') || '',
      productHandle: root.getAttribute('data-product-handle') || '',
      productTitle: root.getAttribute('data-product-title') || '',
      clientId: getClientId(),
      antiAbuseVersion: 'deterministic_email_device_lock_v1',
      createdAt: new Date().toISOString()
    };
  }

  function deterministicEmailExtraCents(root, email) {
    var minCents = parseMoneyCents(root.getAttribute('data-email-extra-min-cents'), 100);
    var maxCents = parseMoneyCents(root.getAttribute('data-email-extra-max-cents'), 500);
    var stepCount = Math.max(1, Math.floor((maxCents - minCents) / 100) + 1);
    var bucket = Math.abs(hashString(email + '|' + root.getAttribute('data-product-id') + '|' + campaignId(root) + '|' + HASH_SALT)) % stepCount;
    return minCents + bucket * 100;
  }

  function revealResult(root, result, options) {
    options = options || {};
    root.classList.add('is-cut');
    root.classList.toggle('is-email-unlocked', result.stage === 'email_bonus');
    root.dataset.unlockerState = result.stage === 'email_bonus' ? 'email_bonus_unlocked' : 'tap_unlocked';

    if (result.stage === 'email_bonus') {
      setText(root, '[data-top-badge]', 'FINAL PRICE RESERVED');
      setText(root, '[data-step-badge]', 'READY TO CLAIM');
      setText(root, '[data-unlocker-title]', 'Your extra cut is locked');
      setText(root, '[data-unlocker-subtitle]', 'Your reserved deal is ready.');
      setText(root, '[data-card-label]', 'Final Price');
      setText(root, '[data-card-status]', 'Ready');
      setText(root, '[data-price-note]', 'You got an extra ' + formatSavingsAmount(root, result.emailExtraCents) + ' off');
      setText(root, '[data-pd-add-cart]', 'Add final price to cart');
      setText(root, '[data-pd-claim]', 'Claim Final Price');
      setText(root, '[data-fineprint]', result.discountCode ? 'Your discount is ready – proceed to checkout.' : 'Your final price will be applied at checkout.');
    } else {
      setText(root, '[data-top-badge]', 'PRICE CUT UNLOCKED');
      setText(root, '[data-step-badge]', 'EMAIL FOR EXTRA');
      setText(root, '[data-unlocker-title]', 'Nice - your tap cut is live');
      setText(root, '[data-unlocker-subtitle]', 'Want one more cut? Add email to reveal a fixed bonus.');
      setText(root, '[data-card-label]', 'Reserved Price');
      setText(root, '[data-card-status]', 'Discount active');
      setText(root, '[data-price-note]', 'Discount active. Add email for one extra fixed bonus.');
      setText(root, '[data-pd-add-cart]', 'Add to cart with discount');
      setText(root, '[data-pd-claim]', canShowExactPrice(root) ? 'Claim ' + formatMoney(root, result.priceCents) + ' Now' : 'Claim ' + formatShopMoney(root, result.savingCents) + ' Off');
      setText(root, '[data-fineprint]', 'Your bonus is set.');
    }

    setPriceValue(root, result, options.animateFromCents);
    updateReceiptRows(root, result);
    updateClaimHref(root, result);
  }

  function setPriceValue(root, result, animateFromCents) {
    if (!canShowExactPrice(root)) {
      setText(root, '[data-price-value]', formatShopMoney(root, result.savingCents) + ' off');
      return;
    }

    if (typeof animateFromCents === 'number' && animateFromCents !== result.priceCents) {
      animatePrice(root, animateFromCents, result.priceCents);
      return;
    }

    setText(root, '[data-price-value]', formatMoney(root, result.priceCents));
  }

  function animatePrice(root, fromCents, toCents) {
    var element = root.querySelector('[data-price-value]');
    if (!element || window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setText(root, '[data-price-value]', formatMoney(root, toCents));
      return;
    }

    var duration = 320;
    var startTime = 0;
    var from = Number(fromCents) || 0;
    var to = Number(toCents) || 0;

    window.requestAnimationFrame(function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min(1, (timestamp - startTime) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(from + (to - from) * eased);
      element.textContent = formatMoney(root, current);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        element.textContent = formatMoney(root, to);
      }
    });
  }

  function updateReceiptRows(root, result) {
    var currentPriceCents = getCurrentPriceCents(root);
    var comparePriceCents = getComparePriceCents(root);
    var siteDealSavingsCents = Math.max(0, comparePriceCents - currentPriceCents);
    var baseDiscountCents = getBaseDiscountCents(root);
    var cutButton = root.querySelector('[data-pd-first-cut]');

    if (cutButton) {
        cutButton.disabled = !!result;
        cutButton.textContent = result ? 'Cut applied' : 'Cut My Price';
    }
    setText(root, '[data-receipt-msrp]', getComparePriceDisplay(root, Math.max(comparePriceCents, currentPriceCents)));
    setText(root, '[data-receipt-site-deal]', result && siteDealSavingsCents > 0 && canShowExactPrice(root) ? formatDiscount(root, siteDealSavingsCents) : getCurrentPriceDisplay(root, currentPriceCents));
    setText(root, '[data-receipt-tap-cut]', result ? formatDiscount(root, baseDiscountCents) : 'Locked');

    var hasEmailBonus = result && result.stage === 'email_bonus';
    setHidden(root, '[data-receipt-email-row]', !hasEmailBonus);
    setHidden(root, '[data-receipt-final-row]', !result);

    if (hasEmailBonus) {
      setText(root, '[data-receipt-email-bonus]', formatDiscount(root, result.emailExtraCents));
      setText(root, '[data-receipt-final-label]', 'Final price');
    } else {
      setText(root, '[data-receipt-email-bonus]', '');
      setText(root, '[data-receipt-final-label]', 'Your price');
    }

    if (result) {
      setText(root, '[data-receipt-final-price]', canShowExactPrice(root) ? formatMoney(root, result.priceCents) : formatShopMoney(root, result.savingCents) + ' off');
    }
  }

  function formatDisplayPrice(root, cents) {
    return canShowExactPrice(root) ? formatMoney(root, cents) : formatShopMoney(root, cents);
  }

  function getCurrentPriceDisplay(root, fallbackCents) {
    return root.getAttribute('data-current-price-display') || formatDisplayPrice(root, fallbackCents);
  }

  function getComparePriceDisplay(root, fallbackCents) {
    return root.getAttribute('data-compare-price-display') || formatDisplayPrice(root, fallbackCents);
  }

  function formatSavingsAmount(root, cents) {
    return canShowExactPrice(root) ? formatCompactMoney(root, cents) : formatShopMoney(root, cents);
  }

  function formatDiscount(root, cents) {
    return '-' + formatSavingsAmount(root, cents);
  }

  function setHidden(root, selector, hidden) {
    var element = root.querySelector(selector);
    if (element) element.hidden = hidden;
  }

  function updateClaimHref(root, result) {
    var claim = root.querySelector('[data-pd-claim]');
    if (!claim || !result || !result.discountCode) return;

    var selectedVariant = getSelectedVariant(root);
    var params = new URLSearchParams();
    params.set('attributes[_pd_unlock_stage]', result.stage || '');
    params.set('attributes[_pd_unlock_price]', centsToMajor(result.priceCents));
    params.set('attributes[_pd_unlock_saving]', centsToMajor(result.savingCents));
    params.set('attributes[_pd_unlock_email_hash]', result.emailHash || '');
    params.set('attributes[_pd_unlock_campaign]', campaignId(root));
    params.set('attributes[_pd_unlock_source]', 'pd_price_unlocker');
    params.set('attributes[_pd_unlock_variant_id]', selectedVariant.id);
    params.set('attributes[_pd_unlock_variant_title]', selectedVariant.title || '');

    var routeRoot = getShopifyRouteRoot();
    var cartPath = routeRoot + 'cart/' + encodeURIComponent(selectedVariant.id) + ':' + encodeURIComponent(getSelectedQuantity()) + '?' + params.toString();
    var discountParams = new URLSearchParams();
    discountParams.set('redirect', cartPath);

    claim.href = routeRoot + 'discount/' + encodeURIComponent(result.discountCode) + '?' + discountParams.toString();
  }

  function addToCartWithDiscount(root, result, button) {
    hideError(root);

    var selectedVariant = getSelectedVariant(root);
    if (!selectedVariant || !selectedVariant.id) {
      showError(root, 'Please select an available option before adding to cart.');
      return;
    }

    if (!result.discountCode) {
      showError(root, 'Discount setup is not ready yet. Please try again later.');
      return;
    }

    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    var sectionsToBundle = getCartSectionsToBundle(selectedVariant);

    addUnlockedVariantToCart(root, result, selectedVariant, sectionsToBundle)
      .then(function (addResponse) {
        return applyBestPdDiscountToCart(root, result, selectedVariant, sectionsToBundle);
      }, function (error) {
        console.warn('[PD Price Unlocker] Cart add failed', error);
        if (error) error.pdCartAddFailed = true;
        throw error;
      })
      .catch(function (error) {
        if (error && error.pdCartAddFailed) throw error;
        console.warn('[PD Price Unlocker] Discount apply failed after cart add', error);

        return getCartJson(getShopifyRouteRoot()).then(function (cart) {
          return {
            cart: cart,
            items: cart.items || [],
            appliedCode: '',
            discountError: error
          };
        }, function (cartError) {
          if (isCartVerificationError(cartError)) {
            return {
              cart: {},
              items: [],
              appliedCode: '',
              discountError: error,
              cartRefreshError: cartError,
              addedButUnconfirmed: true
            };
          }

          throw cartError;
        });
      })
      .then(function (discountState) {
        pushEvent('pd_add_to_cart_with_discount', {
          product_id: root.getAttribute('data-product-id') || '',
          variant_id: selectedVariant.id,
          quantity: getSelectedQuantity(),
          price: centsToMajor(result.priceCents),
          saving: centsToMajor(result.savingCents),
          requested_discount_code: result.discountCode,
          applied_discount_code: discountState.appliedCode,
          discount_status: discountState.discountError ? 'not_applied' : 'applied',
          stage: result.stage
        });

        refreshCartUi(discountState.cart, discountState.items);

        if (button) {
          button.disabled = false;
          button.textContent = discountState.discountError ? 'Added to cart' : 'Added - discount applied';

          window.setTimeout(function () {
            button.textContent = getAddCartButtonLabel(result);
          }, 2200);
        }

        if (discountState.addedButUnconfirmed || isCartVerificationError(discountState.discountError) || isCartVerificationError(discountState.cartRefreshError)) {
          showError(root, 'Added to cart, but connection verification stopped the cart refresh. Please open cart to confirm your discount.');
        } else if (discountState.discountError) {
          showError(root, 'Added to cart, but the discount was not applied. Please use code ' + result.discountCode + ' at checkout.');
        }
      })
      .catch(function (error) {
        console.warn('[PD Price Unlocker] Add to cart flow failed', error);
        if (button) {
          button.disabled = false;
          button.textContent = originalText || 'Add to cart with discount';
        }
        showError(root, isCartVerificationError(error) ? CART_VERIFICATION_MESSAGE : 'Could not add this deal to cart. Please try again.');
      });
  }

  function getActionableResult(root) {
    if (isResultCompatible(root, root.__pdUnlockerResult)) return root.__pdUnlockerResult;

    var saved = readJson(deviceKey(root));
    if (isResultCompatible(root, saved)) return saved;

    if (root.classList.contains('is-email-unlocked') || root.dataset.unlockerState === 'email_bonus_unlocked') {
      return null;
    }

    if (root.classList.contains('is-cut') || root.dataset.unlockerState === 'tap_unlocked') {
      var result = createFirstCutResult(root);
      saveResult(root, result);
      return result;
    }

    return null;
  }

  function showMissingUnlockFeedback(root) {
    if (root.classList.contains('is-email-unlocked') || root.dataset.unlockerState === 'email_bonus_unlocked') {
      showError(root, 'Please reveal your extra cut again before adding this deal to cart.');
      return;
    }

    if (root.classList.contains('is-cut') || root.dataset.unlockerState === 'tap_unlocked') {
      showError(root, 'Please tap Cut My Price again, then add this deal to cart.');
      return;
    }

    showError(root, 'Please tap Cut My Price before adding this deal to cart.');
  }

  function addUnlockedVariantToCart(root, result, selectedVariant, sectionsToBundle) {
    var routeRoot = getShopifyRouteRoot();
    var payload = {
      items: [{
        id: selectedVariant.id,
        quantity: getSelectedQuantity(),
        properties: {
          '_pd_unlock_stage': result.stage || '',
          '_pd_unlock_price': centsToMajor(result.priceCents),
          '_pd_unlock_saving': centsToMajor(result.savingCents),
          '_pd_unlock_email_hash': result.emailHash || '',
          '_pd_unlock_campaign': campaignId(root),
          '_pd_unlock_source': 'pd_price_unlocker_add_to_cart',
          '_pd_unlock_discount_code': result.discountCode,
          '_pd_unlock_variant_title': selectedVariant.title || ''
        }
      }]
    };

    if (sectionsToBundle.length > 0) {
      payload.sections = sectionsToBundle.join(',');
      payload.sections_url = routeRoot + 'variants/' + encodeURIComponent(selectedVariant.id);
    }

    return fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return parseCartJsonResponse(response, 'Cart add failed');
    });
  }

  function applyBestPdDiscountToCart(root, result, selectedVariant, sectionsToBundle) {
    var routeRoot = getShopifyRouteRoot();

    return getCurrentCartDiscountCodes(routeRoot)
      .then(function (existingCodes) {
        var pdOptions = getPdDiscountOptions(root);
        var pdCodeKeys = pdOptions.map(function (option) {
          return normalizeCode(option.code);
        }).concat(LEGACY_PD_DISCOUNT_CODES.map(normalizeCode));
        var bestCode = getBestPdDiscountCode(root, result.discountCode, existingCodes);
        var nextCodes = existingCodes.filter(function (code) {
          return pdCodeKeys.indexOf(normalizeCode(code)) === -1;
        });

        if (bestCode) nextCodes.push(bestCode);

        var payload = { discount: nextCodes.join(',') };

        if (sectionsToBundle.length > 0) {
          payload.sections = sectionsToBundle.join(',');
          payload.sections_url = routeRoot + 'variants/' + encodeURIComponent(selectedVariant.id);
        }

        return fetch(routeRoot + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          return parseCartJsonResponse(response, 'Cart discount update failed');
        }).then(function (cart) {
          var discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
          var applied = discountCodes.find(function (discount) {
            return normalizeCode(discount.code) === normalizeCode(bestCode);
          });

          if (bestCode && applied && applied.applicable === false) {
            throw new Error('PD discount is not applicable');
          }

          return getCartJson(routeRoot).then(function (freshCart) {
            if (cart.sections && Object.keys(cart.sections).length > 0) {
              freshCart.sections = cart.sections;
            }

            return {
              cart: freshCart,
              items: freshCart.items || [],
              appliedCode: bestCode
            };
          });
        });
      });
  }

  function getCartSectionsToBundle(selectedVariant) {
    var sections = ['variant-added'];

    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));
    } catch (error) {}

    return sections.filter(function (section, index) {
      return section && sections.indexOf(section) === index;
    });
  }

  function refreshCartUi(cart, items) {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: items || [],
          cart: cart || {}
        }
      }));
    } catch (error) {}

    if (cart && cart.sections && Object.keys(cart.sections).length > 0) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cart
        }
      }));
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  function getCartJson(routeRoot) {
    return fetch(routeRoot + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      return parseCartJsonResponse(response, 'Cart fetch failed');
    });
  }

  function getAddCartButtonLabel(result) {
    return result && result.stage === 'email_bonus' ? 'Add final price to cart' : 'Add to cart with discount';
  }

  function getCurrentCartDiscountCodes(routeRoot) {
    return fetch(routeRoot + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      return parseCartJsonResponse(response, 'Cart fetch failed');
    }).then(function (cart) {
      var discounts = cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      return discounts.map(function (discount) {
        return discount && discount.code;
      }).filter(Boolean);
    }).catch(function (error) {
      if (isCartVerificationError(error)) throw error;
      return [];
    });
  }

  function parseCartJsonResponse(response, fallbackMessage) {
    return response.text().then(function (text) {
      var json = null;

      try {
        json = text ? JSON.parse(text) : null;
      } catch (error) {}

      if (isVerificationResponse(response, text)) {
        throw createCartError(CART_VERIFICATION_MESSAGE, { verification: true, status: response.status });
      }

      if (!response.ok) {
        throw createCartError(json && (json.description || json.message) || fallbackMessage || 'Cart request failed', { status: response.status });
      }

      if (!json) {
        throw createCartError(fallbackMessage || 'Cart request returned an unexpected response', { status: response.status });
      }

      return json;
    });
  }

  function isVerificationResponse(response, text) {
    var contentType = response && response.headers && response.headers.get ? response.headers.get('content-type') || '' : '';
    var body = String(text || '').toLowerCase();

    return response && response.status === 429
      || contentType.indexOf('text/html') !== -1 && (
        body.indexOf('your connection needs to be verified') !== -1
        || body.indexOf('verification') !== -1 && body.indexOf('proceed') !== -1
        || body.indexOf('challenge-platform') !== -1
        || body.indexOf('/cdn-cgi/challenge-platform') !== -1
      );
  }

  function createCartError(message, options) {
    var error = new Error(message);
    options = options || {};
    if (options.verification) error.pdCartVerificationFailed = true;
    if (options.status) error.status = options.status;
    return error;
  }

  function isCartVerificationError(error) {
    return !!(error && error.pdCartVerificationFailed);
  }

  function getBestPdDiscountCode(root, requestedCode, existingCodes) {
    var bestCode = requestedCode || '';
    var bestTier = getPdDiscountTier(root, bestCode);

    (existingCodes || []).forEach(function (code) {
      var tier = getPdDiscountTier(root, code);
      if (tier > bestTier) {
        bestTier = tier;
        bestCode = getCanonicalPdDiscountCode(root, tier) || code;
      }
    });

    return bestCode;
  }

  function getPdDiscountTier(root, code) {
    var normalized = normalizeCode(code);
    var match = getPdDiscountOptions(root).find(function (option) {
      return normalizeCode(option.code) === normalized;
    });

    return match ? match.tier : 0;
  }

  function getCanonicalPdDiscountCode(root, tier) {
    var match = getPdDiscountOptions(root).find(function (option) {
      return option.tier === tier;
    });

    return match ? match.code : '';
  }

  function getPdDiscountOptions(root) {
    var options = [];

    for (var tier = 5; tier <= 10; tier += 1) {
      var code = root.getAttribute('data-discount-code-' + tier);
      if (code) options.push({ tier: tier, code: code });
    }

    return options;
  }

  function normalizeCode(code) {
    return String(code || '').trim().toLowerCase();
  }

  function getShopifyRouteRoot() {
    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return routeRoot.slice(-1) === '/' ? routeRoot : routeRoot + '/';
  }

  function refreshClaimLinksSoon() {
    window.setTimeout(refreshClaimLinks, 80);
    window.setTimeout(refreshClaimLinks, 250);
    window.setTimeout(refreshClaimLinks, 650);
  }

  function refreshClaimLinks() {
    document.querySelectorAll('#pd-price-unlocker').forEach(function (root) {
      var result = readJson(deviceKey(root));
      if (isResultCompatible(root, result)) updateClaimHref(root, result);
    });
  }

  function isResultCompatible(root, result) {
    if (!result || !result.discountCode) return false;

    var baseDiscountCents = getBaseDiscountCents(root);
    var savingCents = parseMoneyCents(result.savingCents, -1);
    var emailExtraCents = parseMoneyCents(result.emailExtraCents, 0);

    if (result.stage === 'first_cut') {
      return savingCents === baseDiscountCents;
    }

    if (result.stage === 'email_bonus') {
      return savingCents === baseDiscountCents + emailExtraCents;
    }

    return false;
  }

  function getSelectedVariant(root) {
    var supportedIds = getSupportedVariantIds(root);
    var mainFormId = getMainProductFormId();
    var candidate = mainFormId ? normalizeVariantCandidate(getInputValue('form#' + cssEscape(mainFormId) + ' input[name="id"]'), '', 'product_form', supportedIds) : null;
    if (candidate) return candidate;

    candidate = mainFormId
      ? readVariantScript('product-rerender[id^="product-info-"] variant-picker[form-id="' + cssEscape(mainFormId) + '"] script[data-variant]', supportedIds)
      : readVariantScript('product-rerender[id^="product-info-"] variant-picker[form-id^="product-form-"] script[data-variant]', supportedIds);
    if (candidate) return candidate;

    candidate = normalizeVariantCandidate(getInputValue('form[id^="product-form-"][is="product-form"] input[name="id"]'), '', 'product_form_any', supportedIds);
    if (candidate) return candidate;

    candidate = readVariantScript('variant-picker[form-id^="product-form-"] script[data-variant]', supportedIds);
    if (candidate) return candidate;

    candidate = normalizeVariantCandidate(getInputValue('form[action*="/cart/add"] input[name="id"]'), '', 'cart_form', supportedIds);
    if (candidate) return candidate;

    candidate = normalizeVariantCandidate(new URLSearchParams(window.location.search).get('variant'), '', 'url', supportedIds);
    if (candidate) return candidate;

    return normalizeVariantCandidate(root.getAttribute('data-default-variant-id'), '', 'default', supportedIds, true) || { id: root.getAttribute('data-default-variant-id') || '', title: '', source: 'fallback' };
  }

  function getMainProductFormId() {
    var rerender = document.querySelector('product-rerender[id^="product-info-"]');
    var picker = rerender ? rerender.querySelector('variant-picker[form-id]') : document.querySelector('variant-picker[form-id^="product-form-"]');
    var formId = picker ? picker.getAttribute('form-id') : '';
    if (formId) return formId;

    var form = document.querySelector('form[id^="product-form-"][is="product-form"], form[id^="product-form-"]');
    return form ? form.id : '';
  }

  function readVariantScript(selector, supportedIds) {
    var variantScript = document.querySelector(selector);
    if (variantScript && variantScript.textContent) {
      try {
        var variantData = JSON.parse(variantScript.textContent);
        return normalizeVariantCandidate(variantData && variantData.id, variantData && (variantData.public_title || variantData.title), 'variant_script', supportedIds);
      } catch (error) {}
    }

    return null;
  }

  function normalizeVariantCandidate(id, title, source, supportedIds, allowDefault) {
    var value = String(id || '').trim();
    if (!value) return null;
    if (!allowDefault && supportedIds.length > 0 && supportedIds.indexOf(value) === -1) return null;
    return { id: value, title: String(title || '').trim(), source: source };
  }

  function getSupportedVariantIds(root) {
    var raw = root.getAttribute('data-supported-variant-ids') || '';
    return raw.split(',').map(function (id) {
      return id.trim();
    }).filter(Boolean);
  }

  function getSelectedQuantity() {
    var qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getInputValue(selector) {
    var input = document.querySelector(selector);
    return input ? input.value : '';
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value || '').replace(/["\\]/g, '\\$&');
  }

  function saveResult(root, result) {
    root.__pdUnlockerResult = result;
    writeStorage(deviceKey(root), JSON.stringify(result));
    if (result.emailHash) writeStorage(emailKey(root, result.emailHash), JSON.stringify(result));
  }

  function deviceKey(root) {
    return 'protoarc_pd_unlocker_device_result:' + campaignId(root) + ':' + (root.getAttribute('data-product-id') || '');
  }

  function emailKey(root, emailHash) {
    return 'protoarc_pd_unlocker_email_result:' + campaignId(root) + ':' + (root.getAttribute('data-product-id') || '') + ':' + emailHash;
  }

  function attemptKey(root) {
    return 'protoarc_pd_unlocker_email_attempts:' + campaignId(root) + ':' + (root.getAttribute('data-product-id') || '');
  }

  function getClientId() {
    var key = 'protoarc_pd_unlocker_client_id';
    var value = readStorage(key);
    if (!value) {
      value = window.crypto && crypto.randomUUID ? crypto.randomUUID() : 'cid_' + Date.now() + '_' + Math.random().toString(16).slice(2);
      writeStorage(key, value);
    }
    return value;
  }

  function checkAttemptThrottle(root) {
    var now = Date.now();
    var attempts = readJson(attemptKey(root)) || [];
    attempts = attempts.filter(function (timestamp) {
      return now - Number(timestamp) < ATTEMPT_WINDOW_MS;
    });

    if (attempts.length > 0 && now - Number(attempts[attempts.length - 1]) < SUBMIT_COOLDOWN_MS) {
      return { ok: false, message: 'Please wait a few seconds before trying again.' };
    }

    if (attempts.length >= ATTEMPT_LIMIT) {
      return { ok: false, message: 'Too many attempts. Please try again later.' };
    }

    return { ok: true, message: '' };
  }

  function recordAttempt(root) {
    var now = Date.now();
    var attempts = readJson(attemptKey(root)) || [];
    attempts = attempts.filter(function (timestamp) {
      return now - Number(timestamp) < ATTEMPT_WINDOW_MS;
    });
    attempts.push(now);
    writeStorage(attemptKey(root), JSON.stringify(attempts));
  }

  function syncToSheet(root, result) {
    var sheetUrl = root.getAttribute('data-google-sheets-url') || '';
    if (!sheetUrl || !result || result.stage !== 'email_bonus') return;

    var selectedVariant = getSelectedVariant(root);
    fetch(sheetUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: result.email,
        email_hash: result.emailHash,
        product_id: result.productId,
        product_handle: result.productHandle,
        product_title: result.productTitle,
        result_price: centsToMajor(result.priceCents),
        base_saving: centsToMajor(getBaseDiscountCents(root)),
        email_extra: centsToMajor(result.emailExtraCents),
        total_saving: centsToMajor(result.savingCents),
        discount_code: result.discountCode,
        tier: result.tier,
        selected_variant_id: selectedVariant.id,
        selected_variant_title: selectedVariant.title || '',
        campaign_id: result.campaignId,
        client_id: result.clientId,
        anti_abuse_version: result.antiAbuseVersion,
        source: 'shopify_product_pd_unlocker',
        created_at: result.createdAt,
        page_url: window.location.href
      }),
      keepalive: true
    }).catch(function () {});
  }

  function getDiscountCode(root, totalDollars) {
    // TODO: Replace static theme discount codes with a backend/API reservation flow for campaigns without configured Shopify discounts.
    return root.getAttribute('data-discount-code-' + totalDollars) || '';
  }

  function getCurrentPriceCents(root) {
    return parseMoneyCents(root.getAttribute('data-current-price-cents'), 0);
  }

  function getComparePriceCents(root) {
    return parseMoneyCents(root.getAttribute('data-compare-price-cents'), getCurrentPriceCents(root));
  }

  function getBaseDiscountCents(root) {
    return parseMoneyCents(root.getAttribute('data-base-discount-cents'), 1000);
  }

  function parseMoneyCents(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function centsToMajor(cents) {
    return (Math.max(0, Number(cents) || 0) / 100).toFixed(2);
  }

  function formatMoney(root, cents) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var amount = Math.max(0, Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function formatCompactMoney(root, cents) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var safeCents = Math.max(0, Number(cents) || 0);
    var amount = safeCents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: safeCents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + trimMoney(amount);
    }
  }

  function formatShopMoney(root, cents) {
    var currency = root.getAttribute('data-shop-currency') || 'USD';
    var amount = Math.max(0, Number(cents) || 0) / 100;
    if (currency === 'USD') {
      return 'US$' + trimMoney(amount);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return currency + ' ' + trimMoney(amount);
    }
  }

  function trimMoney(amount) {
    return amount.toFixed(2).replace(/\.00$/, '');
  }

  function canShowExactPrice(root) {
    if (root.getAttribute('data-exact-price-preview') === 'true') return true;
    return (root.getAttribute('data-currency') || '') === (root.getAttribute('data-shop-currency') || '');
  }

  function campaignId(root) {
    return root.getAttribute('data-campaign-id') || 'pd-template-test-2026-06';
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function hashString(value) {
    var hash = 0;
    var text = String(value || '');
    for (var i = 0; i < text.length; i += 1) {
      hash = ((hash << 5) - hash) + text.charCodeAt(i);
      hash |= 0;
    }
    return hash;
  }

  function readJson(key) {
    try {
      return JSON.parse(readStorage(key) || 'null');
    } catch (error) {
      return null;
    }
  }

  function readStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  function showError(root, message) {
    var errorEl = root.querySelector('[data-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.add('is-visible');
  }

  function hideError(root) {
    var errorEl = root.querySelector('[data-error]');
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.classList.remove('is-visible');
  }

  function pushEvent(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, unlocker_location: 'pd_product_inline' }, params || {}));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
